import React from "react";
import { Box } from "@mui/material";

const ReferenceIcon = () => {
  return (
    <Box
      sx={{
        position: "relative",
        width: 24,
        height: 24,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        userSelect: "none",
        fontFamily: '"Times New Roman", Times, serif',
        transform: "translate(-2px, -3px)",
      }}
    >
      {/* x */}
      <Box
        sx={{
          fontSize: "30px",
          fontWeight: 900,
          fontStyle: "italic",
          lineHeight: 1,
        }}
      >
        x
      </Box>

      {/* superscript 2 */}
      <Box
        sx={{
          position: "absolute",
          top: 6,
          right: -1,
          fontSize: "11px",
          fontStyle: "italic",
          fontWeight: 600,
          lineHeight: 1,
        }}
      >
        2
      </Box>
    </Box>
  );
};

export default ReferenceIcon;
